import { useState } from 'react';
import EventLightbox from './EventLightbox';

const galleryImages = [
  {
    id: 1,
    src: 'https://static.readdy.ai/image/0890122b367f23c3338a761be89943be/cc207fcf6f305c752ea6b9b84e4e9e58.jpeg',
    alt: 'Outdoor festival coffee catering',
    caption: 'Summer Festival Catering',
  },
  {
    id: 2,
    src: 'https://static.readdy.ai/image/0890122b367f23c3338a761be89943be/3a626d0e7f3396f5a2a44583bd419d8c.jpeg',
    alt: 'Corporate coffee bar setup',
    caption: 'Corporate Office Event',
  },
  {
    id: 3,
    src: 'https://static.readdy.ai/image/0890122b367f23c3338a761be89943be/40dad4a291956f837bb4456598aa807e.jpeg',
    alt: 'Wedding reception beverage station',
    caption: 'Wedding Reception',
  },
  {
    id: 4,
    src: 'https://static.readdy.ai/image/0890122b367f23c3338a761be89943be/965a72ee61ea3a56ef487fb678190292.jpeg',
    alt: 'Farmers market coffee cart',
    caption: 'Farmers Market',
  },
  {
    id: 5,
    src: 'https://static.readdy.ai/image/0890122b367f23c3338a761be89943be/0c17c2644d80fc98e7e50fa99e1f1380.jpeg',
    alt: 'Coffee tasting workshop',
    caption: 'Coffee Tasting Workshop',
  },
  {
    id: 6,
    src: 'https://static.readdy.ai/image/0890122b367f23c3338a761be89943be/3907dc4d73280879d021aa2c72b3d91f.jpeg',
    alt: 'Music festival catering',
    caption: 'Music Festival',
  },
  {
    id: 7,
    src: 'https://static.readdy.ai/image/0890122b367f23c3338a761be89943be/684abcfa9b1fa6d18896615922a509be.jpeg',
    alt: 'Fresh iced lemonade',
    caption: 'Signature Lemonade',
  },
  {
    id: 8,
    src: 'https://static.readdy.ai/image/0890122b367f23c3338a761be89943be/d313bd14b40f8061944430708a5a7557.jpeg',
    alt: 'Charity gala event',
    caption: 'Charity Gala',
  },
  {
    id: 9,
    src: 'https://static.readdy.ai/image/0890122b367f23c3338a761be89943be/604c530a70302e130b7ca252350c832a.jpeg',
    alt: 'Barista making latte art',
    caption: 'Artisan Latte Art',
  },
  {
    id: 10,
    src: 'https://static.readdy.ai/image/0890122b367f23c3338a761be89943be/119e9e006a9eab4cbbd6967f8c581c79.jpeg',
    alt: 'Graduation party catering',
    caption: 'Graduation Celebration',
  },
  {
    id: 11,
    src: 'https://static.readdy.ai/image/0890122b367f23c3338a761be89943be/c2cf16687f9581632f35506e956e8a31.jpeg',
    alt: 'Mobile coffee truck',
    caption: 'Mobile Coffee Truck',
  },
  {
    id: 12,
    src: 'https://static.readdy.ai/image/0890122b367f23c3338a761be89943be/fb03b746c5def397f396d75d8612e370.jpeg',
    alt: 'Corporate team building event',
    caption: 'Team Building Event',
  },
  {
    id: 13,
    src: 'https://static.readdy.ai/image/0890122b367f23c3338a761be89943be/51c47341a3efac1763fff5f48e59d8aa.jpeg',
    alt: 'Cold brew coffee pour',
    caption: 'Cold Brew Specialty',
  },
  {
    id: 14,
    src: 'https://static.readdy.ai/image/0890122b367f23c3338a761be89943be/bdf2627f3d271a670b48e60bee1d0fd4.jpeg',
    alt: 'Bridal shower brunch',
    caption: 'Bridal Shower Brunch',
  },
  {
    id: 15,
    src: 'https://static.readdy.ai/image/0890122b367f23c3338a761be89943be/c8fde303aaf2c5246a88740dfa0eb357.jpeg',
    alt: 'Holiday office party',
    caption: 'Holiday Office Party',
  },
  {
    id: 16,
    src: 'https://static.readdy.ai/image/0890122b367f23c3338a761be89943be/af9c89175fe16fa77233204d5f236e94.jpeg',
    alt: 'Food truck festival',
    caption: 'Food Truck Festival',
  },
  {
    id: 17,
    src: 'https://static.readdy.ai/image/0890122b367f23c3338a761be89943be/225ccbd5bb3e82eacf13e091d745a507.jpeg',
    alt: 'Wellness retreat beverage station',
    caption: 'Wellness Retreat',
  },
  {
    id: 18,
    src: 'https://static.readdy.ai/image/0890122b367f23c3338a761be89943be/ff4f98fe15bb9fa4141a55799aaf000c.jpeg',
    alt: 'Birthday party catering',
    caption: 'Birthday Celebration',
  },
  {
    id: 19,
    src: 'https://static.readdy.ai/image/0890122b367f23c3338a761be89943be/fb03b746c5def397f396d75d8612e370.jpeg',
    alt: 'Specialty lavender lemonade',
    caption: 'Lavender Lemonade',
  },
  {
    id: 20,
    src: 'https://static.readdy.ai/image/0890122b367f23c3338a761be89943be/775db67bc440235656b0eaf2a3be7c7b.jpeg',
    alt: 'Art gallery opening event',
    caption: 'Art Gallery Opening',
  },
  {
    id: 21,
    src: 'https://static.readdy.ai/image/0890122b367f23c3338a761be89943be/423888ad981aa29524ee140763d7dc72.jpeg',
    alt: 'Morning coffee at market',
    caption: 'Morning Market Coffee',
  },
  {
    id: 22,
    src: 'https://static.readdy.ai/image/0890122b367f23c3338a761be89943be/451086a8084d1b5a22b2cfa6885502a8.jpeg',
    alt: 'Tech startup launch party',
    caption: 'Startup Launch Party',
  },
  {
    id: 23,
    src: 'https://static.readdy.ai/image/0890122b367f23c3338a761be89943be/a5e1ba9c0e07bcf2ac0f0f8cb5ceec1c.jpeg',
    alt: 'Friends toasting with coffee',
    caption: 'Shared Moments',
  },
  {
    id: 24,
    src: 'https://static.readdy.ai/image/0890122b367f23c3338a761be89943be/5fed997bcbd0a505b28d43ec473e1252.jpeg',
    alt: 'Company year-end celebration',
    caption: 'Year-End Celebration',
  },
  {
    id: 25,
    src: 'https://static.readdy.ai/image/0890122b367f23c3338a761be89943be/6084bc1164272b020614e978580303ba.jpeg',
    alt: 'Garden party drinks station',
    caption: 'Garden Party',
  },
  {
    id: 26,
    src: 'https://static.readdy.ai/image/0890122b367f23c3338a761be89943be/fa56e5a75456c7ee13bcf4428b94e837.jpeg',
    alt: 'Artisan cold brew pour',
    caption: 'Cold Brew Bar',
  },
  {
    id: 28,
    src: 'https://static.readdy.ai/image/0890122b367f23c3338a761be89943be/7e51adc4854f065d5e51269fb8005c03.jpeg',
    alt: 'Private dinner party catering',
    caption: 'Private Dinner Party',
  },
  {
    id: 29,
    src: 'https://static.readdy.ai/image/0890122b367f23c3338a761be89943be/a3b5844268cfd876ebebc2dce61e8590.jpeg',
    alt: 'Summer block party catering',
    caption: 'Summer Block Party',
  },
  {
    id: 30,
    src: 'https://static.readdy.ai/image/0890122b367f23c3338a761be89943be/b94e8f9d83b0c26901e661a689242a5b.jpeg',
    alt: 'Holiday market hot drinks',
    caption: 'Holiday Market',
  },
  {
    id: 27,
    src: 'https://static.readdy.ai/image/0890122b367f23c3338a761be89943be/31047c53abe4ac45159e3156ce884b64.jpeg',
    alt: 'Rooftop event gathering',
    caption: 'Rooftop Event',
  },
  {
    id: 31,
    src: 'https://public.readdy.ai/ai/img_res/e9ab79c6cee2dd0cc4f35322930449be.jpg',
    alt: 'Garden wedding reception',
    caption: 'Garden Wedding',
  },
  {
    id: 32,
    src: 'https://static.readdy.ai/image/0890122b367f23c3338a761be89943be/57965349096809a707a6bae8c905f67a.jpeg',
    alt: 'Corporate networking cocktail hour',
    caption: 'Networking Cocktail Hour',
  },
  {
    id: 33,
    src: 'https://static.readdy.ai/image/0890122b367f23c3338a761be89943be/0fc9c123fceff2f5020d708544b0d53e.jpeg',
    alt: 'Street food festival',
    caption: 'Street Food Festival',
  },
  {
    id: 34,
    src: 'https://static.readdy.ai/image/0890122b367f23c3338a761be89943be/bb7f7459008af3dca944a7c0f3b18ba9.jpeg',
    alt: 'Baby shower brunch party',
    caption: 'Baby Shower Brunch',
  },
  {
    id: 35,
    src: 'https://static.readdy.ai/image/0890122b367f23c3338a761be89943be/385dfe032075f7b4f106e6cf3835a67f.jpeg',
    alt: 'Charity fundraiser gala dinner',
    caption: 'Charity Fundraiser Gala',
  },
  {
    id: 36,
    src: 'https://static.readdy.ai/image/0890122b367f23c3338a761be89943be/ee4061fa9a85699d94951973a02b72ca.jpeg',
    alt: 'Autumn harvest festival',
    caption: 'Harvest Festival',
  },
];

export default function EventGrid() {
  const [lightboxIndex, setLightboxIndex] = useState<number | null>(null);

  const openLightbox = (index: number) => setLightboxIndex(index);
  const closeLightbox = () => setLightboxIndex(null);
  const goNext = () => setLightboxIndex(prev => (prev !== null ? (prev + 1) % galleryImages.length : null));
  const goPrev = () => setLightboxIndex(prev => (prev !== null ? (prev - 1 + galleryImages.length) % galleryImages.length : null));

  // Split into 3 columns for masonry
  const col1 = galleryImages.filter((_, i) => i % 3 === 0);
  const col2 = galleryImages.filter((_, i) => i % 3 === 1);
  const col3 = galleryImages.filter((_, i) => i % 3 === 2);

  const renderCard = (img: typeof galleryImages[0], globalIndex: number) => (
    <div
      key={img.id}
      className="relative group cursor-pointer overflow-hidden rounded-2xl mb-5"
      onClick={() => openLightbox(globalIndex)}
    >
      <img
        src={img.src}
        alt={img.alt}
        className="w-full h-auto object-cover transition-transform duration-500 group-hover:scale-105"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-all duration-300 flex items-end">
        <div className="w-full px-4 pb-4 translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300">
          <p className="text-white text-sm font-semibold tracking-wide">{img.caption}</p>
        </div>
      </div>
      <div className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300">
        <i className="ri-zoom-in-line text-white text-sm"></i>
      </div>
    </div>
  );

  return (
    <div className="max-w-7xl mx-auto px-4 py-12">
      {/* Header */}
      <div className="flex items-center justify-between mb-10 pb-6 border-b border-stone-200">
        <p className="text-stone-500 text-sm">
          <span className="font-semibold text-stone-700">{galleryImages.length}</span> photos
        </p>
        <p className="text-stone-400 text-xs">Click any photo to view full size</p>
      </div>

      {/* Masonry Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {/* Column 1 */}
        <div>
          {col1.map(img => {
            const globalIndex = galleryImages.findIndex(g => g.id === img.id);
            return renderCard(img, globalIndex);
          })}
        </div>
        {/* Column 2 */}
        <div>
          {col2.map(img => {
            const globalIndex = galleryImages.findIndex(g => g.id === img.id);
            return renderCard(img, globalIndex);
          })}
        </div>
        {/* Column 3 */}
        <div>
          {col3.map(img => {
            const globalIndex = galleryImages.findIndex(g => g.id === img.id);
            return renderCard(img, globalIndex);
          })}
        </div>
      </div>

      {/* Lightbox */}
      {lightboxIndex !== null && (
        <EventLightbox
          images={galleryImages.map(img => ({ publicUrl: img.src, caption: img.caption }))}
          currentIndex={lightboxIndex}
          onClose={closeLightbox}
          onNext={goNext}
          onPrev={goPrev}
        />
      )}
    </div>
  );
}
